import React from "react";
import { Link } from "react-router-dom";
import TrustLayout, { H2 } from "./TrustLayout";

export default function Disclaimer() {
  return (
    <TrustLayout
      meta={{
        path: "/disclaimer",
        kicker: "Read this",
        title: "Financial Education Disclaimer | Centennial",
        description:
          "My Centennial Plan provides educational tools only — not financial, investment, tax, legal, or medical advice. Read the full disclaimer.",
        h1: "Financial Education Disclaimer",
        reviewed: "June 2026",
      }}
    >
      <H2>Not financial advice</H2>
      <p>
        My Centennial Plan is an educational platform. The calculator, projections, guides,
        checklists, and workbook are tools for learning and organizing — they are{" "}
        <strong>not</strong> financial, investment, tax, or legal advice, and they are not a
        recommendation to buy or sell any security. We are not a registered investment advisor,
        broker-dealer, tax preparer, or law firm.
      </p>

      <H2>Projections are estimates</H2>
      <p>
        Monte Carlo simulations and historical stress tests estimate a range of possible
        outcomes based on assumptions about future returns, inflation, and your inputs. Actual
        results will differ. Past performance does not guarantee future results. A "probability
        of success" is a modeling output, not a promise. How the math works is documented on
        the <Link className="text-[#2B5339] underline" to="/methodology">Methodology page</Link>.
      </p>

      <H2>Not medical advice</H2>
      <p>
        The medication safety organizer is for organization and education only. It never
        identifies pills, never recommends dosages, and never replaces your pharmacist, doctor,
        or Poison Control. Do not start, stop, split, combine, or change any medication based on
        anything on this site.
      </p>

      <H2>Talk to professionals</H2>
      <p>
        Before acting on anything you learn here, consider consulting a fiduciary financial
        advisor, a CPA for tax questions, an attorney for estate documents, and your
        pharmacist or physician for medication questions.
      </p>

      <H2>Affiliate disclosure</H2>
      <p>
        Some outbound book and brokerage links are affiliate links — if you buy through them,
        the site may earn a commission at no extra cost to you. Affiliate status never affects
        whether or how we recommend something.
      </p>
    </TrustLayout>
  );
}
